module.exports = __webpack_public_path__ + "static/media/dlt.a7a90e78.svg";